<template>

    <Page>
        <Image src="/PointOfSale/rewards-flyer.png" class="scale-[90%]" />
    </Page>

</template>